import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/actions`;

export const { useGetAll: useAllAction, useGet: useAction } = apiCrudBuilder(
  path,
  "Action",
);

export const useActionAsNote = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (actionId) =>
      appAxios.get(`${path}/${actionId}/as_note/`).then((res) => res.data),
  });
};

export const useActionAttachments = (id, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    enabled: !!id,
    ...options,
    queryKey: ["ActionAttachments", id],
    queryFn: () =>
      appAxios.get(`${path}/${id}/attachments/`).then((res) => res.data),
  });
};

export const useDownloadAction = (id, options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    ...options,
    queryKey: ["ActionObject", id],
    queryFn: () =>
      appAxios.get(`${path}/${id}/download/`).then((res) => res.data),
    enabled: !!id,
  });
};

export const useResetAction = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["all_Action"] });
  };
};

export const useEmailAttachmentWithFile = (id) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useQuery({
    queryKey: ["ActionAttachment", id],
    queryFn: () =>
      appAxios
        .get(`${baseUrl}/email_attachment/${id}/with_file/`)
        .then((res) => res.data),
    enabled: !!id,
  });
};
